export const generateId = () => Math.floor(Math.random() * 10000)
